module.exports = __webpack_public_path__ + "com_index_05fig.png?bc084e2695083c9b871f4e1a858f5c38";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_05fig.png
// module id = 309
// module chunks = 0